import { ReactNode, useMemo } from 'react';
import { appScopeUtils, AppScope } from '../appScope.types';
import { AppScopeContext } from './AppScopeContext';

export type AppScopeProviderProps = {
  scope: AppScope;
  children: ReactNode;
};

export function AppScopeProvider({ scope, children }: AppScopeProviderProps) {
  appScopeUtils.assertValid(scope);
  const value = useMemo(() => scope, [scope]);
  return (
    <AppScopeContext.Provider value={value}>
      {children}
    </AppScopeContext.Provider>
  );
}
